<template>
  <div style="width: 100%; height: 100%;">
    <div class="box" :id="boxId" :class="windowsNum">
      <div v-for="(item, index) in playerProperties" :key="item.wndNo" v-show="item.isShow"
        :class="[displayModel, 'normal']" draggable="true" :style="item.selectWndStyle"
        @click="TriggerClick($event, index)" @dblclick="TriggerDoubleClick($event, index)"
        @contextmenu.prevent="onContextmenu($event, index)" @dragstart="_dragstart(index, $event)"
        @dragend="_dragend($event)" @drop="_drop(index, $event)" @dragover="_dragover($event)">
        <div class="title" v-if="item.videoStatus === 2 || item.videoStatus === 1">
          <div class="title-left">{{ item.displayName }}</div>
          <div class="title-right">{{ item.displayChannel }}</div>
        </div>

        <div class="control" v-if="item.videoStatus === 2 || item.videoStatus === 1">
          <div class="control-left">{{ item.prompt }}</div>
          <div class="control-right">
            <!--暂停和继续播放-->
            <i :class="item.videoStatus == 2 ? 'photograph_pause' : 'photograph_play'
              " :title="item.videoStatus == 2 ? $t('videom.暂停') : $t('videom.继续')"
              @click="_switchPlayPause(index)"></i>

            <i class="photograph_jietu" @click="_captureCurrentWnd(index)" :title="$t('videom.抓拍')"></i>

            <div class="volume-control" v-if="snd" @mouseenter="item._showVolume = true"
              @mouseleave="item._showVolume = false">
              <i :class="item.muteOrVoice" :title="item.muteOrVoice === 'mute_black' ? $t('videom.打开声音') : $t('videom.关闭声音')
                " @click="SwitchSoundWnd(index)"></i>
              <input v-show="item._showVolume && num < 25" type="range" min="0" max="1" step="0.05"
                :value="item.volume || 1" @input="setVolumeWnd(index, $event.target.value)" class="volume-slider"
                :title="$t('videom.音量')" />
            </div>

            <i v-if="false" class="photograph_black"
              :title="item.recordStatus === 0 ? $t('videom.开始录像') : $t('videom.结束录制')"
              @click="SwitchRecordWnd(index)"></i>
            <i class="photograph_stop" @click="CloseCurrentWnd(index)" :title="$t('videom.停止')"></i>

            <i class="photograph_full" :title="$t('videom.全屏')" @click="_fullCurrentWnd(index)"></i>
          </div>
        </div>
        <div class="videoPlayer">
          <!-- -->
          <div class="video-center-img" v-if="!(item.videoStatus === 2 || item.videoStatus === 1)">
            <div class="no_video"></div>
            <div class="no_title">{{ $t('videom.暂无视频') }}</div>
          </div>
          <div :class="'video-rotate rotate' + item.rotate.toString()">
            <play-base :video-player="playerProperties[index]"></play-base>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 0px; height: 0px; overflow: hidden">
      <canvas id="kl_canvas" width="515" height="300"></canvas>
    </div>
    <audio-play v-if="audioPlayer" :audio-player="audioPlayer" style="display: none"></audio-play>
  </div>
</template>
<script>
import PlayBase from "./PlayBase";
import VideoPlayer from "./VideoPlayer";
import AudioPlayer from "./AudioPlayer";
import AudioPlay from "./AudioPlay";

export default {
  props: {
    boxId: {
      type: String,
      default: "box1"
    },
    playMode: {
      type: String,
      default: "real", //history or real 历史或者实时
    },
  },
  components: {
    PlayBase,
    AudioPlay,
  },
  data() {
    return {

      captionInfo: "captionInfoShow",
      captionInfoPop: "captionInfoTop",
      snd: 0,
      num: 0,
      displayModel: "sfull",
      windowsNum: "box4", //当前是几个 box1 box4 box6 box9 box10 box16 box25 box36 box48 box64 box100
      videoPlayer: null,
      playerProperties: [],
      audioPlayer: new AudioPlayer(22),
      $index: null,
      playerType: 0,
      isVideoPlayer: true,
      isRealTimePlay: true, //是否是实时播放
      canvas: null, //用来截图或者录制视频的canvas元素
      moveIndex: null,
      targetIndex: null,
      lastClickTime: null,
    };
  },
  created() { },
  methods: {
    SetWait(simNum, iChannelId, plateNum) {
      console.log("setWait");
      this._clearDesignatedCar(simNum, iChannelId);
      for (var r = null, s = 0; s < this.playerProperties.length; s++) {
        var a = this.playerProperties[s];
        if (
          (null == r && 1 != a.videoStatus && 2 != a.videoStatus && (r = a),
            a.simNum == simNum && a.iChannelId == iChannelId)
        ) {
          r = a;
          break;
        }
      }
      if (null != r) {
        var l = r.setWait(simNum, iChannelId, plateNum);
        return (r = null), l;
      }
    },
    ConfirmConn(simNum, iChannelId, sessionid, serverip, tcpport, isRealPlay) {
      console.log("ConfirmConn1");
      console.log(simNum);
      console.log(iChannelId);
      var l = this._getWndIndex(simNum, iChannelId);
      console.log("wndIndex_" + l);
      if (l >= 0) {
        this.lastClickTime = new Date().getTime();
        var h = this.playerProperties[l];
        h.confirmConn(sessionid, serverip, tcpport, isRealPlay);
      }
    },
    _clearDesignatedCar(t, e) {
      var i = this._getWndIndex(t, e);
      if (i + 1 > 0) {
        var o = this.playerProperties[i];
        o.clearContent();
      }
    },
    CloseAllWnd() {
      for (var t = 0; t < this.playerProperties.length; t++)
        this._closeSelectedWnd(t);
    },
    CloseCurrentWnd(index) {
      this._closeSelectedWnd(index);
    },
    _closeSelectedWnd(t) {
      null != t &&
        2 == this.playerProperties[t].videoStatus &&
        this.playerProperties[t].stop();
    },
    SwitchRecordWnd(e) {
      // var i = this.$index;
      // if (null == i)
      //     return -1;
      var o = this.playerProperties[e];
      // this.$index = e;
      return 0 == o.recordStatus ? o.startRecord(e) : o.stopRecord();
    },
    onContextmenu(event, index) {
      var item = this.playerProperties[index];
      if (item.videoStatus === 2 || item.videoStatus === 1) {
        this.$contextmenu({
          items: [
            {
              label: item.videoStatus === 2 ? this.$t('videom.暂停') : this.$t('videom.继续'),
              // icon: "el-icon-refresh",
              onClick: () => {
                this._switchPlayPause(index);
              },
            },
            {
              label: this.$t('videom.抓拍'),
              // icon: "el-icon-refresh",
              onClick: () => {
                this._captureCurrentWnd(index);
              },
            },
            {
              label:
                item.muteOrVoice === "mute_black" ? this.$t('videom.打开声音') : this.$t('videom.关闭声音'),
              onClick: () => {
                this.SwitchSoundWnd(index);
              },
            },
            {
              label: this.$t('videom.停止'),
              // icon: "el-icon-refresh",
              onClick: () => {
                this.CloseCurrentWnd(index);
              },
            },
            {
              label: this.$t('videom.全屏'),
              // icon: "el-icon-refresh",
              onClick: () => {
                this._fullCurrentWnd(index);
              },
            },

            // {
            //   label: item.recordStatus === 0 ? $t('videom.开始录制') : $t('videom.结束录制'),
            //   icon: "el-icon-refresh",
            //   onClick: () => {
            //     this.SwitchRecordWnd(index);
            //   },
            // },
          ],
          event,
          customClass: "right-menu-class",
          zIndex: 2002,
          minWidth: 160,
        });
      }

      return false;
    },

    TriggerDoubleClick(t, e) {
      //全屏显示
      this._fullCurrentWnd(e);
    },
    TriggerClick(t, e) {
      this._selectWnd(e);
    },
    _dragstart(t, e) {
      e.dataTransfer.setData("text", this.playerProperties);
      this.moveIndex = t;
    },
    _dragover(t) {
      t.preventDefault();
    },
    _dragend(t) { },
    _drop(t, e) {
      e.preventDefault();
      e.stopPropagation();
      this.targetIndex = t;
      //拷贝this.playerProperties并生成

      var i = Array.from(this.playerProperties),
        o = i[this.targetIndex];
      (i[this.targetIndex] = i[this.moveIndex]),
        (i[this.moveIndex] = o),
        (this.playerProperties = i),
        this._selectWnd(this.targetIndex),
        0 == this.targetIndex && 35 == this.moveIndex
          ? (this._preChangeDebug = !0)
          : (this._preChangeDebug &&
            35 == this.targetIndex &&
            0 == this.moveIndex &&
            ((this._debugMode = !this._debugMode),
              this._setDebugMode(this._debugMode)),
            (this._preChangeDebug = !1));
    },
    _selectWnd(t) {
      10 == this.playerProperties[t].delay &&
        (this.lastClickTime = new Date().getTime());

      if (this.$index == null) {
        this.playerProperties[t].selectWndStyle = "border : 2px solid #2A7AFF";
        this.$index = t;
      } else {
        var e = this.$index;
        if (t != e) {
          if (e >= 0 && e < this.playerProperties.length)
            this.playerProperties[e].selectWndStyle =
              "border : 2px solid #222222";

          this.playerProperties[t].selectWndStyle =
            "border : 2px solid #2A7AFF";
          this.$index = t;
        }
      }
    },

    // SwitchRecordWnd: function (t, e) {
    //   //切换录像指令
    //   var i = this.$index;
    //   if (null == i) return -1;
    //   var o = this.playerProperties[i];
    //   return 1 == t ? o.startRecord(e) : o.stopRecord();
    // },

    SwitchSoundWnd(t) {
      //开关音频，直接控制video的音频开关是否可以
      this._switchSound(t);
    },
    _switchPlayPause(index) {
      var palyer = this.playerProperties[index];
      if (palyer.getPaused()) {
        palyer.play(), (palyer.videoStatus = 2);
      } else {
        //isPlaying
        if (palyer.VideoPlay.isPlaying()) {
          //暂停播放
          palyer.pause(), (palyer.videoStatus = 1);
        }
      }
    },
    SetWndPromptWord(simNum, iChannelId, prompt) {
      //开关音频，直接控制video的音频开关是否可以

      var l = this._getWndIndex(simNum, iChannelId);
      if (l >= 0) {
        var h = this.playerProperties[l];
        h.setPromptWord(prompt);
      }
    },
    SetPlaybackRate(simNum, iChannelId, rate) {
      var l = this._getWndIndex(simNum, iChannelId);
      if (l >= 0) {
        var h = this.playerProperties[l];
        h.setPlaybackRate(rate);
      }
    },
    _getWndIndex(simNum, iChannelId) {
      var i = -1;
      if ("" == simNum) return i;
      for (var o = 0; o < this.playerProperties.length; o++)
        if (
          this.playerProperties[o].simNum == simNum &&
          this.playerProperties[o].iChannelId == iChannelId
        ) {
          i = o;
          break;
        }
      return i;
    },
    GetWndBySimNum(simNum) {
      return this.playerProperties.filter((item) => item.simNum === simNum);
    },
    GetWndBySimChannel(simNum, iChannelId) {
      return this.playerProperties.filter(
        (item) => item.simNum === simNum && item.iChannelId === iChannelId
      );
    },
    GetAllWnd(simNum) {
      return this.playerProperties;
    },
    _switchSound(t) {
      var e = this.audioPlayer.audioStatus; //音频开关状态，当前正在播放音频
      if (1 == e) {
        //判断当前播放的是不是点击的这个，如果不是，就关闭，然后开启目前点击的
        var i = this._getWndIndex(
          this.audioPlayer.simNum,
          this.audioPlayer.iChannelId
        );
        i == t
          ? this.playerProperties[t].closeAudio()
          : (i >= 0 && this.playerProperties[i].closeAudio(),
            this.playerProperties[t].openAudio());
      } else this.playerProperties[t].openAudio();
    },
    setVolumeWnd(index, volume) {
      var player = this.playerProperties[index];
      var vol = parseFloat(volume);
      player.setVolume(vol);
      // 如果当前窗口的音频正在通过 AudioPlayer 播放，同步音量
      if (
        this.audioPlayer.audioStatus === 1 &&
        this.audioPlayer.simNum === player.simNum &&
        this.audioPlayer.iChannelId === player.iChannelId
      ) {
        this.audioPlayer.setVolume(vol);
      }
    },
    _captureCurrentWnd(index) {
      return this._capture(index);
    },
    /**
     * 捕获当前视频窗口的截图
     * @param {number} t - 播放器属性数组的索引
     */
    _capture(t) {
      console.log("截图1");
      // 获取指定索引的播放器属性
      const player = this.playerProperties[t];
      console.log("截图2", player.videoStatus);
      // 检查视频状态是否为 2
      if (player.videoStatus === 2) {
        console.log("截图3");
        console.log(player);
        // 获取媒体信息
        const mediaInfo = player.getMediaInfo();
        console.log(mediaInfo);
        // 检查媒体信息是否有效

        try {
          // 根据编码格式选择不同的元素
          let videoElement = document.querySelector(`#${player.videoId}`);

          // 获取或创建画布元素
          if (!this.canvas) {
            this.canvas = document.getElementById("kl_canvas");
          }
          if (mediaInfo && mediaInfo.width && mediaInfo.height) {
            // 设置画布的宽度和高度
            this.canvas.width = mediaInfo.width;
            this.canvas.height = mediaInfo.height;
          }
          // 获取画布的 2D 上下文
          const ctx = this.canvas.getContext("2d");
          // 将视频元素绘制到画布上
          ctx.drawImage(
            videoElement,
            0,
            0,
            this.canvas.width,
            this.canvas.height
          );

          // 获取画布的 Base64 编码图像数据
          var dataURL = this.canvas.toDataURL("image/png");

          const link = document.createElement("a");
          link.href = dataURL;
          link.download = "screenshot.png";
          // 模拟点击下载链接
          link.click();
        } catch (error) {
          // 处理捕获过程中可能出现的错误
          console.error("截图捕获失败:", error);
        }
      }
    },
    _fullCurrentWnd(index) {
      var e = this.playerProperties[index];
      this._inFullSreeen(e.videoId);
    },
    FullWndScreen() {
      //全屏能力
      this._inFullSreeen(this.boxId);
    },
    _inFullSreeen(domId) {
      //指定对象id就可以 video_0
      var t = document.getElementById(domId),
        e =
          t.requestFullScreen ||
          t.webkitRequestFullScreen ||
          t.mozRequestFullScreen ||
          t.msRequestFullScreen;
      if ("undefined" != typeof e && e) e.call(t);
      else if ("undefined" != typeof window.ActiveXObject) {
        var i = new ActiveXObject("WScript.Shell");
        null != i && i.SendKeys("{F11,Esc}");
      }
    },
    SetWindowsNum(num) {
      this._setWindowsNum(num);
    },
    /**
     * 设置窗口数量和布局
     * @param {number} t - 窗口的总数量
     * @param {boolean} e - 一个布尔值，用于决定是否调用 M.setPlayerLayOut 函数
     * @param {number} i - 布局的行数
     * @param {number} o - 布局的列数
     */
    _setWindowsNum(t, e, i, o) {
      // 根据不同的条件设置窗口的类名

      // 其他情况，将窗口类名设置为 'box' 加上总窗口数
      this.windowsNum = `box${t}`;

      // 遍历所有的播放器属性，设置显示状态和类名
      for (let r = 0; r < this.playerProperties.length; r++) {
        const s = this.playerProperties[r];
        // 如果总窗口数小于等于播放器属性的数量，且当前索引大于等于总窗口数，则隐藏该窗口
        s.isShow = !(t <= this.playerProperties.length) || r < t;
        // 如果窗口被隐藏且正在播放音频，则关闭音频
        if (
          !s.isShow &&
          this.audioPlayer.audioStatus === 1 &&
          this.audioPlayer.simNum === s.simNum &&
          this.audioPlayer.iChannelId === s.iChannelId
        ) {
          s.closeAudio();
        }
        // 设置窗口的类名为 'normal'
        s.wndClassName = "normal";
      }

      // 如果总窗口数大于播放器属性的数量，添加新的播放器
      if (t > this.playerProperties.length) {
        const a = t - this.playerProperties.length;
        // 调用 _addPlayer 函数添加新的播放器
        this._addPlayer(this.playerProperties.length, t, a);
      }
    },
    _initVideo() {
      this._addPlayer(0, 4, 4); //添加4个窗口
      this.audioPlayer.videoPlayer = this.playerProperties[0];
      // this.$index = 0;
    },
    _addPlayer(t, e, i) {
      //添加几个播放窗体  i 窗体数量
      var o;
      this.num = e;
      for (var n = 0; n < i; n++) {
        o = new VideoPlayer(t, this.playerType, this.isVideoPlayer, this.playMode == "real" ? 0 : 1);
        o.isShow = n < e;
        (o.audioPlayer = this.audioPlayer),
          //   o.videoplayBg = this.brightBg,
          //   o.brightBg = this.brightBg,
          //   o.darkBg = this.darkBg,
          (o.isRealTimePlay = this.isRealTimePlay);
        this.playerProperties.push(o), t++;
      }
    },
  },
  mounted() {
    this._initVideo();
  },
};
</script>
<style scoped>
.box {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background-color: #222222;
}

.box>div>.title,
.box>div>.control {
  height: 28px;
  position: absolute;
  z-index: 9;
  background: #00000061;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.box>div>.control>.control-left {
  flex: 1;
  margin-left: 12px;
  text-align: left;
}

.box>div>.control>.control-right {
  display: flex;
  margin-right: 12px;
  text-align: right;
}

.box>div>.title>.title-left {
  flex: 1;
  margin-left: 12px;
  text-align: left;
}

.box>div>.title>.title-right {
  margin-right: 12px;
  text-align: right;
}

.box>div>.control {
  bottom: 0;
}

.box>div>.videoPlayer {
  /* todo 添加背景图片,实际要用设计稿替换 */
  background-color: #666666;
  background-size: cover;
  background-position: center;
}

.box>div>.videoPlayer>.video-center-img {
  display: flex;
  position: absolute;
  left: 44%;
  top: 35%;
  flex-direction: column;
  align-items: center;
}

.box>div>.videoPlayer>.video-center-img>.no_video {
  width: 60px;
  height: 60px;
  margin-bottom: 6px;
  background-image: url("~@/assets/images/icon_zanwushipin.png");
  background-size: cover;
}

.box>div>.videoPlayer>.video-center-img>.no_title {
  font-size: 12px;
  color: #aaaaaa;
}

.box16>div>.videoPlayer>.video-center-img>.no_video,
.box25>div>.videoPlayer>.video-center-img>.no_video {
  width: 30px !important;
  height: 30px !important;
  margin-bottom: 3px !important;
}

.box16>div>.videoPlayer>.video-center-img>.no_title,
.box25>div>.videoPlayer>.video-center-img>.no_title {
  font-size: 10px;
}

.box36>div>.videoPlayer>.video-center-img>.no_video,
.box48>div>.videoPlayer>.video-center-img>.no_video {
  width: 30px !important;
  height: 30px !important;
}

.box64>div>.videoPlayer>.video-center-img>.no_video,
.box100>div>.videoPlayer>.video-center-img>.no_video {
  width: 20px !important;
  height: 20px !important;
}

.box36>div>.videoPlayer>.video-center-img>.no_title,
.box48>div>.videoPlayer>.video-center-img>.no_title,
.box64>div>.videoPlayer>.video-center-img>.no_title,
.box100>div>.videoPlayer>.video-center-img>.no_title {
  display: none !important;
}

.box36>div>.control,
.box48>div>.control,
.box64>div>.control,
.box100>div>.control,
.box36>div>.title,
.box48>div>.title,
.box64>div>.title,
.box100>div>.title {
  display: none !important;
}

.box>div>.control>.control-right>i {
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 8px;
}

.box>div>.control>.control-right>.volume-control {
  margin-right: 8px;
}

.box>div>.control>.control-right>.volume-control>i {
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 0;
}

.box>div>.control>.control-right>i:hover,
.box>div>.control>.control-right>.volume-control>i:hover {
  background-color: #2a7aff;
}

.box>div.s43>.videoPlayer>.video-rotate,
.box>div.s169>.videoPlayer>.video-rotate,
.box>div>.videoPlayer>.video-rotate.rotate0,
.box>div>.videoPlayer>.video-rotate.rotate180 {
  width: 100%;
  height: 100%;
}

.box>.original .video-play {
  -o-object-fit: contain !important;
  object-fit: contain !important;
}

.box>div {
  float: left;
  border: 2px solid #222222;
  padding: 3px;
  background-color: #222222;
  position: relative;
}

.box1>div {
  width: calc((100% - 0px) / 1);
  height: calc((100% - 0px) / 1);
}

.box1>div .play {
  max-width: 54px !important;
  max-height: 54px !important;
  width: 50vh !important;
  height: 50vh !important;
}

.box1>div.s43>.videoPlayer,
.fullScreen.s43>.videoPlayer {
  width: calc((100% - 0px) / 1 - 6px) !important;
  height: calc(((100% - 0px) / 1 - 6px) * 3 / 4) !important;
  max-height: calc((100% - 4px) / 1 - 26px) !important;
  max-width: calc(((100% - 4px) / 1 - 26px) * 4 / 3) !important;
  margin: calc(((100% - 4px) / 1 - 26px - ((100% - 4px) / 1 - 6px) * 3 / 4) / 2) auto !important;
}

.box1>div.s169>.videoPlayer,
.fullScreen.s169>.videoPlayer {
  width: calc((100% - 0px) / 1 - 6px) !important;
  height: calc(((100% - 0px) / 1 - 6px) * 9 / 16) !important;
  max-height: calc((100% - 4px) / 1 - 26px) !important;
  max-width: calc(((100% - 4px) / 1 - 26px) * 16 / 9) !important;
  margin: calc(((100% - 4px) / 1 - 26px - ((100% - 4px) / 1 - 6px) * 9 / 16) / 2) auto !important;
}

.box1>div.sfull .video-rotate.rotate90,
.fullScreen.sfull .video-rotate.rotate90 {
  position: absolute;
  height: calc((100% - 0px) / 1 - 6px);
  width: calc((100% - 0px) / 1 - 26px);
  margin-left: calc((100% - 4px) / 1 - 6px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.box1>div.sfull .video-rotate.rotate180,
.fullScreen.sfull .video-rotate.rotate180 {
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.box1>div.sfull .video-rotate.rotate270,
.fullScreen.sfull .video-rotate.rotate270 {
  position: absolute;
  height: calc((100% - 4px) / 1 - 6px);
  width: calc((100% - 4px) / 1 - 26px);
  margin-top: calc((100% - 4px) / 1 - 26px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.box4>div {
  width: calc((100% - 0px) / 2);
  height: calc((100% - 0px) / 2);
  /*根据工具栏的高度定义*/
}

.box4>div .play {
  max-width: 54px !important;
  max-height: 54px !important;
  width: 25vh !important;
  height: 25vh !important;
}

.box4>.normal.s43>.videoPlayer {
  width: calc((100% - 6px) / 2 - 6px) !important;
  height: calc(((100% - 6px) / 2 - 6px) * 3 / 4) !important;
  max-height: calc((100% - 6px) / 2 - 26px);
  max-width: calc(((100% - 6px) / 2 - 26px) * 4 / 3);
  margin: calc(((100% - 6px) / 2 - 26px - ((100% - 6px) / 2 - 6px) * 3 / 4) / 2) auto;
}

.box4>.normal.s169>.videoPlayer {
  width: calc((100% - 6px) / 2 - 6px) !important;
  height: calc(((100% - 6px) / 2 - 6px) * 9 / 16) !important;
  max-height: calc((100% - 6px) / 2 - 26px);
  max-width: calc(((100% - 6px) / 2 - 26px) * 16 / 9);
  margin: calc(((100% - 6px) / 2 - 26px - ((100% - 6px) / 2 - 6px) * 9 / 16) / 2) auto;
}

.box4>div.sfull.normal .video-rotate.rotate90 {
  position: absolute;
  height: calc((100% - 6px) / 2 - 6px);
  width: calc((100% - 6px) / 2 - 26px);
  margin-left: calc((100% - 6px) / 2 - 6px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.box4>div.sfull.normal .video-rotate.rotate180 {
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.box4>div.sfull.normal .video-rotate.rotate270 {
  position: absolute;
  height: calc((100% - 6px) / 2 - 6px);
  width: calc((100% - 6px) / 2 - 26px);
  margin-top: calc((100% - 6px) / 2 - 26px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.box6>div,
.box9>div {
  width: calc((100% - 0px) / 3);
  height: calc((100% - 0px) / 3);
}

.box6>div .play,
.box9>div .play {
  max-width: 54px !important;
  max-height: 54px !important;
  width: 16.66667vh !important;
  height: 16.66667vh !important;
}

.box6>.normal.s43>.videoPlayer,
.box9>.normal.s43>.videoPlayer {
  width: calc((100% - 8px) / 3 - 6px) !important;
  height: calc(((100% - 8px) / 3 - 6px) * 3 / 4) !important;
  max-height: calc((100% - 8px) / 3 - 26px);
  max-width: calc(((100% - 8px) / 3 - 26px) * 4 / 3);
  margin: calc(((100% - 8px) / 3 - 26px - ((100% - 8px) / 3 - 6px) * 3 / 4) / 2) auto;
}

.box6>.normal.s169>.videoPlayer,
.box9>.normal.s169>.videoPlayer {
  width: calc((100% - 8px) / 3 - 6px) !important;
  height: calc(((100% - 8px) / 3 - 6px) * 9 / 16) !important;
  max-height: calc((100% - 8px) / 3 - 26px);
  max-width: calc(((100% - 8px) / 3 - 26px) * 16 / 9);
  margin: calc(((100% - 8px) / 3 - 26px - ((100% - 8px) / 3 - 6px) * 9 / 16) / 2) auto;
}

.box6>div:first-of-type {
  width: calc((200% - 0px) / 3 - 2px);
  height: calc((200% - 0px) / 3 - 2px);
}

.box6>div:first-of-type.s43>.videoPlayer {
  width: calc((200vw - 4px) / 3 - 8px) !important;
  height: calc((200vw - 104px) / 3 - 6.5px) !important;
  max-height: calc((200vh - 104px) / 3 - 28px);
  max-width: calc(((200vh - 4px) / 3 - 8px) * 4 / 3);
  margin: calc(((200vh - 4px) / 3 - 28px - (200vw - 4px) / 3 + 6.5px) / 2) auto;
}

.box6>div:first-of-type.s169>.videoPlayer {
  width: calc((200vw - 4px) / 3 - 8px) !important;
  height: calc((200vw - 104px) / 3 - 5.375px) !important;
  max-height: calc((200vh - 104px) / 3 - 28px);
  max-width: calc(((200vh - 4px) / 3 - 8px) * 16 / 9);
  margin: calc(((200vh - 4px) / 3 - 28px - (200vw - 4px) / 3 + 5.375px) / 2) auto;
}

.box6>div:nth-of-type(4) {
  clear: both;
}

.box6>div.sfull.normal .video-rotate.rotate90,
.box9>div.sfull.normal .video-rotate.rotate90 {
  position: absolute;
  height: calc((100% - 58px) / 3 - 6px);
  width: calc((100% - 8px) / 3 - 26px);
  margin-left: calc((100% - 8px) / 3 - 6px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.box6>div.sfull.normal .video-rotate.rotate180,
.box9>div.sfull.normal .video-rotate.rotate180 {
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.box6>div.sfull.normal .video-rotate.rotate270,
.box9>div.sfull.normal .video-rotate.rotate270 {
  position: absolute;
  height: calc((100% - 8px) / 3 - 6px);
  width: calc((100% - 8px) / 3 - 26px);
  margin-top: calc((100% - 8px) / 3 - 26px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.box6>div:first-of-type.sfull.normal .video-rotate.rotate90 {
  position: absolute;
  height: calc((200vw - 4px) / 3 - 8px);
  width: calc((200vh - 4px) / 3 - 8px);
  margin-left: calc((200vw - 4px) / 3 - 8px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.box6>div:first-of-type.sfull.normal .video-rotate.rotate270 {
  position: absolute;
  height: calc((200vw - 4px) / 3 - 8px);
  width: calc((200vh - 4px) / 3 - 8px);
  margin-top: calc((200vh - 4px) / 3 - 8px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.box10>div,
.box16>div {
  width: calc((100% - 0px) / 4);
  height: calc((100% - 0px) / 4);
}

.box10>div .play,
.box16>div .play {
  max-width: 54px !important;
  max-height: 54px !important;
  width: 12.5vh !important;
  height: 12.5vh !important;
}

.box10>.normal.s43>.videoPlayer,
.box16>.normal.s43>.videoPlayer {
  width: calc((100% - 10px) / 4 - 6px) !important;
  height: calc(((100% - 10px) / 4 - 6px) * 3 / 4) !important;
  max-height: calc((100% - 10px) / 4 - 26px);
  max-width: calc(((100% - 10px) / 4 - 26px) * 4 / 3);
  margin: calc(((100% - 10px) / 4 - 26px - ((100% - 10px) / 4 - 6px) * 3 / 4) / 2) auto;
}

.box10>.normal.s169>.videoPlayer,
.box16>.normal.s169>.videoPlayer {
  width: calc((100% - 10px) / 4 - 6px) !important;
  height: calc(((100% - 10px) / 4 - 6px) * 9 / 16) !important;
  max-height: calc((100% - 10px) / 4 - 26px);
  max-width: calc(((100% - 10px) / 4 - 26px) * 16 / 9);
  margin: calc(((100% - 10px) / 4 - 26px - ((100% - 10px) / 4 - 6px) * 9 / 16) / 2) auto;
}

.box10>div:first-of-type,
.box10>div:nth-of-type(2) {
  width: calc((100% - 0px) / 2);
  height: calc((100% - 0px) / 2);
}

.box10>div:first-of-type .play,
.box10>div:nth-of-type(2) .play {
  max-width: 54px !important;
  max-height: 54px !important;
  width: 25vh !important;
  height: 25vh !important;
}

.box10>.normal:first-of-type.s43>.videoPlayer,
.box10>.normal:nth-of-type(2).s43>.videoPlayer {
  width: calc((100% - 0px) / 2 - 6px) !important;
  height: calc(((100% - 0px) / 2 - 6px) * 3 / 4) !important;
  max-height: calc((100% - 6px) / 2 - 26px);
  max-width: calc(((100% - 6px) / 2 - 26px) * 4 / 3);
  margin: calc(((100% - 6px) / 2 - 26px - ((100% - 6px) / 2 - 6px) * 3 / 4) / 2) auto;
}

.box10>.normal:first-of-type.s169>.videoPlayer,
.box10>.normal:nth-of-type(2).s169>.videoPlayer {
  width: calc((100% - 0px) / 2 - 6px) !important;
  height: calc(((100% - 0px) / 2 - 6px) * 9 / 16) !important;
  max-height: calc((100% - 6px) / 2 - 26px);
  max-width: calc(((100% - 6px) / 2 - 26px) * 16 / 9);
  margin: calc(((100% - 6px) / 2 - 26px - ((100% - 6px) / 2 - 6px) * 9 / 16) / 2) auto;
}

.box10>div.sfull.normal .video-rotate.rotate90,
.box16>div.sfull.normal .video-rotate.rotate90 {
  position: absolute;
  height: calc((100% - 0px) / 4 - 6px);
  width: calc((100% - 0px) / 4 - 26px);
  margin-left: calc((100% - 10px) / 4 - 6px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.box10>div.sfull.normal .video-rotate.rotate180,
.box16>div.sfull.normal .video-rotate.rotate180 {
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.box10>div.sfull.normal .video-rotate.rotate270,
.box16>div.sfull.normal .video-rotate.rotate270 {
  position: absolute;
  height: calc((100% - 0px) / 4 - 6px);
  width: calc((100% - 0px) / 4 - 26px);
  margin-top: calc((100% - 10px) / 4 - 26px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.box10>div:first-of-type.sfull.normal .video-rotate.rotate90,
.box10>div:nth-of-type(2).sfull.normal .video-rotate.rotate90 {
  position: absolute;
  height: calc((100% - 0px) / 2 - 6px);
  width: calc((100% - 0px) / 2 - 26px);
  margin-left: calc((100% - 6px) / 2 - 6px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.box10>div:first-of-type.sfull.normal .video-rotate.rotate270,
.box10>div:nth-of-type(2).sfull.normal .video-rotate.rotate270 {
  position: absolute;
  height: calc((100% - 0px) / 2 - 6px);
  width: calc((100% - 0px) / 2 - 26px);
  margin-top: calc((100% - 6px) / 2 - 26px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.box25>div {
  width: calc((100% - 0px) / 5);
  height: calc((100% - 0px) / 5);
}

.box25>div .play {
  max-width: 54px !important;
  max-height: 54px !important;
  width: 10vh !important;
  height: 10vh !important;
}

.box25>.normal.s43>.videoPlayer {
  width: calc((100% - 12px) / 5 - 6px) !important;
  height: calc(((100% - 12px) / 5 - 6px) * 3 / 4) !important;
  max-height: calc((100% - 12px) / 5 - 26px);
  max-width: calc(((100% - 12px) / 5 - 26px) * 4 / 3);
  margin: calc(((100% - 12px) / 5 - 26px - ((100% - 12px) / 5 - 6px) * 3 / 4) / 2) auto;
}

.box25>.normal.s169>.videoPlayer {
  width: calc((100% - 12px) / 5 - 6px) !important;
  height: calc(((100% - 12px) / 5 - 6px) * 9 / 16) !important;
  max-height: calc((100% - 12px) / 5 - 26px);
  max-width: calc(((100% - 12px) / 5 - 26px) * 16 / 9);
  margin: calc(((100% - 12px) / 5 - 26px - ((100% - 12px) / 5 - 6px) * 9 / 16) / 2) auto;
}

.box25>div.sfull.normal .video-rotate.rotate90 {
  position: absolute;
  height: calc((100% - 12px) / 5 - 6px);
  width: calc((100% - 12px) / 5 - 26px);
  margin-left: calc((100% - 12px) / 5 - 6px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.box25>div.sfull.normal .video-rotate.rotate180 {
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.box25>div.sfull.normal .video-rotate.rotate270 {
  position: absolute;
  height: calc((100% - 12px) / 5 - 6px);
  width: calc((100% - 12px) / 5 - 26px);
  margin-top: calc((100% - 12px) / 5 - 26px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.box36>div {
  width: calc((100% - 0px) / 6);
  height: calc((100% - 0px) / 6);
}

.box36>div .play {
  max-width: 54px !important;
  max-height: 54px !important;
  width: 8.33333vh !important;
  height: 8.33333vh !important;
}

.box36>.normal.s43>.videoPlayer {
  width: calc((100% - 14px) / 6 - 6px) !important;
  height: calc(((100% - 14px) / 6 - 6px) * 3 / 4) !important;
  max-height: calc((100% - 14px) / 6 - 26px);
  max-width: calc(((100% - 14px) / 6 - 26px) * 4 / 3);
  margin: calc(((100% - 14px) / 6 - 26px - ((100% - 14px) / 6 - 6px) * 3 / 4) / 2) auto;
}

.box36>.normal.s169>.videoPlayer {
  width: calc((100% - 14px) / 6 - 6px) !important;
  height: calc(((100% - 14px) / 6 - 6px) * 9 / 16) !important;
  max-height: calc((100% - 14px) / 6 - 26px);
  max-width: calc(((100% - 14px) / 6 - 26px) * 16 / 9);
  margin: calc(((100% - 14px) / 6 - 26px - ((100% - 14px) / 6 - 6px) * 9 / 16) / 2) auto;
}

.box36>div.sfull.normal .video-rotate.rotate90 {
  position: absolute;
  height: calc((100% - 14px) / 6 - 6px);
  width: calc((100% - 14px) / 6 - 26px);
  margin-left: calc((100% - 14px) / 6 - 6px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.box36>div.sfull.normal .video-rotate.rotate180 {
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

.box36>div.sfull.normal .video-rotate.rotate270 {
  position: absolute;
  height: calc((100% - 14px) / 6 - 6px);
  width: calc((100% - 14px) / 6 - 26px);
  margin-top: calc((100% - 14px) / 6 - 26px);
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}

.box48>div {
  width: calc((100% - 0px) / 8);
  height: calc((100% - 0px) / 6);
}

.box64>div {
  width: calc((100% - 0px) / 8);
  height: calc((100% - 0px) / 8);
}

.box100>div {
  width: calc((100% - 0px) / 10);
  height: calc((100% - 0px) / 10);
}

/*   
  .box36 > div .play {
    max-width: 54px !important;
    max-height: 54px !important;
    width: 8.33333vh !important;
    height: 8.33333vh !important;
  }
  
  .box36 > .normal.s43 > .videoPlayer {
    width: calc((100% - 14px) / 6 - 6px) !important;
    height: calc(((100% - 14px) / 6 - 6px) * 3 / 4) !important;
    max-height: calc((100% - 14px) / 6 - 26px);
    max-width: calc(((100% - 14px) / 6 - 26px) * 4 / 3);
    margin: calc(
        ((100% - 14px) / 6 - 26px - ((100% - 14px) / 6 - 6px) * 3 / 4) / 2
      )
      auto;
  }
  
  .box36 > .normal.s169 > .videoPlayer {
    width: calc((100% - 14px) / 6 - 6px) !important;
    height: calc(((100% - 14px) / 6 - 6px) * 9 / 16) !important;
    max-height: calc((100% - 14px) / 6 - 26px);
    max-width: calc(((100% - 14px) / 6 - 26px) * 16 / 9);
    margin: calc(
        ((100% - 14px) / 6 - 26px - ((100% - 14px) / 6 - 6px) * 9 / 16) / 2
      )
      auto;
  }
  
  .box36 > div.sfull.normal .video-rotate.rotate90 {
    position: absolute;
    height: calc((100% - 14px) / 6 - 6px);
    width: calc((100% - 14px) / 6 - 26px);
    margin-left: calc((100% - 14px) / 6 - 6px);
    -webkit-transform-origin: left top;
    transform-origin: left top;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  
  .box36 > div.sfull.normal .video-rotate.rotate180 {
    -webkit-transform-origin: center center;
    transform-origin: center center;
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  
  .box36 > div.sfull.normal .video-rotate.rotate270 {
    position: absolute;
    height: calc((100% - 14px) / 6 - 6px);
    width: calc((100% - 14px) / 6 - 26px);
    margin-top: calc((100% - 14px) / 6 - 26px);
    -webkit-transform-origin: left top;
    transform-origin: left top;
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  } */
.photograph_pause {
  background-image: url("~@/assets/images/icon_zantingbofang.png");
}

.photograph_play {
  background-image: url("~@/assets/images/icon_bofang.png");
}

.photograph_full {
  background-image: url("~@/assets/images/icon_fangda.png");
}

.photograph_stop {
  background-image: url("~@/assets/images/icon_tingzhibofang.png");
}

.photograph_jietu {
  background-image: url("~@/assets/images/icon_jieping.png");
}

.mute_black {
  background-image: url("~@/assets/images/icon_feijingyin.png");
}

.voice_black {
  background-image: url("~@/assets/images/icon_jingyin.png");
}

.volume-control {
  display: flex;
  align-items: center;
  position: relative;
}

.volume-slider {
  width: 60px;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  outline: none;
  margin-left: 4px;
  cursor: pointer;
}

.volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
}

.volume-slider::-moz-range-thumb {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  border: none;
}
</style>
